import ErrorPage from "../errors/ErrorPage"
import MilestonesReportPortuguese from "./milestones-report-languages/MilestonesReportPortuguese"
import MilestonesReportSpanish from "./milestones-report-languages/MilestonesReportSpanish"

type PropsT  = {
    language: any;
}

const MilestonesReportePage = ({language}:PropsT) => {
    switch(language){
        case 'es': return <MilestonesReportSpanish />
        case 'pt': return <MilestonesReportPortuguese />
        default: return <ErrorPage />
    }
}

export default MilestonesReportePage
